import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../../store';
import { CursorType } from '../../../configs/constant';

type CameraStateType = {
  cameras: any[];
  cursor: CursorType;
  limit: number;
  total: number;
};

const initialState: CameraStateType = { cameras: [], cursor: {}, limit: 10, total: 0 };

const slice = createSlice({
  name: 'cameraState',
  initialState: initialState,
  reducers: {
    setCameras: (
      state, 
      { payload: { cameras, cursor, total } }: PayloadAction<{ cameras: any[]; cursor: CursorType; total:number }>
    ) => {
      state.cameras = cameras;
      state.cursor = cursor;
      if (typeof total === 'number') {
        state.total = total;
      }
    },
    setLimit: (state, { payload: { limit } }: PayloadAction<{ limit: number }>) => {
      state.limit = limit;
    },
    setCursor: (state, action: PayloadAction<CursorType>) => {
      state.cursor = action.payload;
    },
  },
});

export const { setCameras, setLimit, setCursor } = slice.actions;

export default slice.reducer;

export const selectCameraState = (state: RootState) => state.cameraState;
export const selectCameras = (state: RootState) => state.cameraState.cameras;
export const selectCursor = (state: RootState) => state.cameraState.cursor;
